export interface productMain {
    /**
     * 상품 카테고리코드
     * 입출금 : '103'
        적금∙청약 : '101'
        예금∙중금채 : '102'
        체크카드 : '302'
        신용카드 : '301'
        대출 : '600'
        보험 : '400'
        퇴직연금(IRP) : 'A00'
        ISA : '800'
        펀드 : '500'
     */
    catlDcd: string //상품 카테고리코드
    sortNam: string //추천
    tabviewAllYn: boolean //탭메뉴 전체여부
}

export const initialState: productMain = {
    catlDcd: '103',
    sortNam: '추천순',
    tabviewAllYn: false,
}

export const initProductMain: productMain = {
    catlDcd: '103',
    sortNam: '추천순',
    tabviewAllYn: false,
}
